//@flow
import ProductModel from '../Stores/Products/productModel';

import type ProductsCollection from '../Stores/Products/productsCollection';
import type QuoteItemsCollection from '../Stores/Quote/quoteItemsCollection';
import type { OrderItemObject } from '../Stores/Order/orderItemModel';

// 2nd gift package product sku in each array will eventually replace the 1st
// One of the two for each tuple will always be disabled
const giftSkus = {
  '8004DR06': ['1371PR06', '6004DR06'],
  '8004DR12': ['1372PR12', '6004DR12'],
  '8004DR20': ['1373PR20', '6004DR20'],
  '8004DR50': ['6004DR50'],
};

const EGIFT_SKU = 'nbxegift';
const GIFT_MEMB_PLAN = 'free_mem_botm';

export default {
  /*
  * Map of gift simple skus to package product skus
  * Gift product detail pages use the package product sku
  * to display photos and descriptions of associated products
  */
  getMappedProduct(product:ProductModel, products:ProductsCollection):ProductModel {
    const mappedProductSkus = giftSkus[product.getSku()];
    if (!mappedProductSkus || product.isPackage()) return product;

    const giftPackageProducts = products.getProductsBySkus(mappedProductSkus);
    // giftPackageProducts is an array with just one product, as one of two giftPackageSkus is always disabled
    return giftPackageProducts[0] || product;
  },

  hasEgiftInCart(items:QuoteItemsCollection):boolean {
    return items.getSkus().some(sku => sku === EGIFT_SKU);
  },

  hasEgiftInOrder(items:OrderItemObject[]):boolean {
    return items.some(item => item.sku === EGIFT_SKU);
  },

  EGIFT_SKU,

  GIFT_MEMB_PLAN,
};
